// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7894b0e0","796":"232c725d"}[chunkId] + ".chunk.js";
};